// Cached query data belongs to whoever was signed in when it was fetched.

export interface SessionIdentity {
  token: string | null;
  user: { id: number } | null;
}

/**
 * True when the signed-in identity changed: a sign-out, a sign-in as someone
 * else, or an impersonation starting or ending. Cached data must not outlive
 * that, or the next account is shown the previous one's lines and credits for
 * as long as the cache keeps them.
 */
export function identityChanged(prev: SessionIdentity, next: SessionIdentity): boolean {
  return prev.token !== next.token || (prev.user?.id ?? null) !== (next.user?.id ?? null);
}
